import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchGamezopGames } from '../services/gameService';
import { GAMEZOP } from '../utils/constants';

const AppContext = createContext();

const DARK_VARS = {
  '--bg-primary': '#0f1117',
  '--bg-secondary': '#16181f',
  '--bg-card': '#1c1f2a',
  '--bg-hover': '#22263a',
  '--text-primary': '#f0f2f8',
  '--text-secondary': '#9aa0b8',
  '--text-muted': '#6b7280',
  '--border': 'rgba(255,255,255,0.06)',
};

const LIGHT_VARS = {
  '--bg-primary': '#f3f4f8',
  '--bg-secondary': '#ffffff',
  '--bg-card': '#ffffff',
  '--bg-hover': '#f0f2f8',
  '--text-primary': '#0f1117',
  '--text-secondary': '#4b5563',
  '--text-muted': '#9ca3af',
  '--border': 'rgba(0,0,0,0.08)',
};

const applyTheme = (isDark) => {
  const vars = isDark ? DARK_VARS : LIGHT_VARS;
  Object.entries(vars).forEach(([k, v]) =>
    document.documentElement.style.setProperty(k, v)
  );
  document.documentElement.classList.toggle('dark', isDark);
};

export const AppProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(true);
  const [gamesList, setGamesList] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem('darkMode');
    const isDark = saved !== null ? saved === 'true' : true;
    setDarkMode(isDark);
    applyTheme(isDark);
  }, []);

  useEffect(() => {
    fetchGamezopGames(GAMEZOP.ID_SECONDARY || '11190')
      .then(setGamesList)
      .catch(() => {});
  }, []);

  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      const next = !prev;
      localStorage.setItem('darkMode', next);
      applyTheme(next);
      return next;
    });
  };

  return (
    <AppContext.Provider value={{ darkMode, toggleDarkMode, gamesList }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);

// Backward-compat alias (existing components use useDarkMode)
export const useDarkMode = useAppContext;

export default AppContext;
